import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit?limit=300").then((r) => setLogs(r.data)); }, []);
  return (
    <div className="p-4 md:p-6">
      <Link to="/admin" className="text-xs text-muted-foreground hover:text-primary">← Admin</Link>
      <div className="my-3">
        <div className="label-tech mb-1">Compliance</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Audit Log</h1>
      </div>
      <div className="card-flat border-border overflow-hidden">
        <div className="max-h-[75vh] overflow-auto">
          <table className="w-full text-xs font-mono">
            <thead className="bg-muted/60 border-b border-border sticky top-0 z-10">
              <tr className="text-left label-tech">
                <th className="px-3 py-2">Timestamp</th>
                <th className="px-3 py-2">User</th>
                <th className="px-3 py-2">Action</th>
                <th className="px-3 py-2">Entity</th>
                <th className="px-3 py-2">ID</th>
                <th className="px-3 py-2">Reason</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {logs.map((l) => (
                <tr key={`${l.timestamp}-${l.entity}-${l.entity_id}-${l.action}`} className="hover:bg-muted/30">
                  <td className="px-3 py-1.5 whitespace-nowrap">{new Date(l.timestamp).toLocaleString()}</td>
                  <td className="px-3 py-1.5">{l.user_email}</td>
                  <td className="px-3 py-1.5"><span className="text-primary">{l.action}</span></td>
                  <td className="px-3 py-1.5">{l.entity}</td>
                  <td className="px-3 py-1.5">{l.entity_id}</td>
                  <td className="px-3 py-1.5 text-muted-foreground">{l.reason}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr><td colSpan={6} className="p-6 text-center text-muted-foreground">No audit entries yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
